import {User}									from '../user/interface';

import * as API									from '../../ressources/API';


export default {
	getDashboardApi: async (user: User) => {
		const response = await API.getDashboard(user);
		if (!response || !response.status)
			return undefined;
		return response.data;
	}
};
